<app-browse-guest-title
  [platformType]="platformService?.platformType"
  (becomeACustomerClickEmitter)="onBecomeACustomerClick()"
></app-browse-guest-title>
<div class="browse-container">
  <div class="main-browse-content">
    <div class="browse-carousel">
      <app-browse-categories-skeleton
        *ngIf="browseHierarchyViewModel?.state === 'loading'"
      ></app-browse-categories-skeleton>
      <app-search-browse-carousel
        *ngIf="
          browseHierarchyViewModel?.state === 'loaded' &&
          browseHierarchyViewModel?.categories.length > 0
        "
        [categories]="browseHierarchyViewModel?.categories"
        [displayGuestTitle]="true"
      ></app-search-browse-carousel>
    </div>
    <div class="browse-view-all-products">
      <ion-button
        data-cy="view-all-products-button"
        class="usf-outline-green-button"
        [routerLink]="[searchPath]"
        [queryParams]="{
          searchFilterProperties: '0',
          categoryId: '0',
          pageType: 'all',
        }"
      >
        {{ 'i18n.search.browsePage.viewAllProducts' | translate }}
      </ion-button>
    </div>
    <app-zip-code-banner [isGuestUser]="isGuestUser"></app-zip-code-banner>
    <a
      data-cy="browse-banner-scoop"
      [routerLink]="[searchPath]"
      [queryParams]="browseScoopParams"
      class="browse-banner"
    >
      <img [src]="scoopImageUrl" />
    </a>
    <div class="top-seller-carousel" *ngIf="newTopSellers?.length > 0">
      <app-recommendation-carousel
        [title]="'i18n.productDetail.recommendations.topSellers' | translate"
        [products]="newTopSellers"
        [platformType]="platformService?.platformType"
        (quantityUpdateEmitter)="onTopSellerQuantityUpdate($event)"
        (productClickEmitter)="onProductCardClick($event)"
        [linkSource]="topSellerLnkSrc"
        [addMethod]="TOP_SELLER_FEATURE_NAME"
        [isGuestUser]="isGuestUser"
      ></app-recommendation-carousel>
    </div>
    <a
      [routerLink]="[searchPath]"
      [queryParams]="directQueryParams"
      class="browse-banner"
      *ngIf="isDirectEligible"
    >
      <img class="direct" [src]="directImageUrl" />
    </a>
    <div class="es-banner">
      <div class="shadow">
        <div class="es-content bold">
          <span class="es-title">{{
            'i18n.search.browsePage.equipmentSupplies.title' | translate
          }}</span>
          {{ 'i18n.search.browsePage.equipmentSupplies.textBody' | translate }}
          <ion-button
            class="usf-outline-green-button es-button"
            [routerLink]="[searchPath]"
            [queryParams]="neweandsParams"
            >{{
              'i18n.search.browsePage.equipmentSupplies.shopNow' | translate
            }}</ion-button
          >
        </div>
      </div>
    </div>
    <div
      class="recently-viewed-carousel"
      *ngIf="!isGuestUser && (recentlyViewedProducts$ | async)?.length > 0"
    >
      <app-merchandising-product-carousel
        [products]="recentlyViewedProducts$ | async"
        [platformType]="platformService?.platformType"
        [title]="'i18n.home.recentlyViewed' | translate"
        [linkSource]="recentlyViewedLnkSrc"
        [merchFeature]="RECENTLY_VIEWED_FEATURE_NAME"
        [addMethod]="RECENTLY_VIEWED_FEATURE_NAME"
        [isGuestUser]="isGuestUser"
        (quantityUpdateEmitter)="onRecentlyViewedQuantityUpdate($event)"
      ></app-merchandising-product-carousel>
    </div>
  </div>
</div>
